import React, { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setChatboardSelectedTab,
  setShowPinnedMessage,
} from "../redux/chatSlice";
import {
  AnsweredFillIcon,
  AnsweredIcon,
  CompletedFillIcon,
  CompletedIcon,
  MessageFillIcon,
  MessageIcon,
  PhoneSupportIcon,
  UnansweredFillIcon,
  UnansweredIcon,
} from "../../assets/icons/svg";
import {
  getObjectLength,
  SUPPORT_ADMIN_IDS,
  SUPPORT_NAME,
} from "../Helpers/common";

const SupportBoardHeader = () => {
  const { authSessionUser } = useSelector((state) => state.authUserDetail);
  const isSupportAdmin = SUPPORT_ADMIN_IDS.includes(authSessionUser?.user_id);

  const dispatch = useDispatch();

  const { chatboardSelectedTab, unreadThreadListObj, chatRoom } = useSelector(
    (state) => state?.chat || {},
  );

  const activeUnreadThreadList = unreadThreadListObj[chatRoom];

  const handleTabing = (tab) => {
    if (tab === "pins") {
      dispatch(setShowPinnedMessage(true));
    }
    dispatch(setChatboardSelectedTab(tab));
  };

  const TABS = [
    ...(isSupportAdmin
      ? [
          {
            key: "unanswered",
            label: "Unanswered",
            activeIcon: UnansweredFillIcon,
            icon: UnansweredIcon,
            aria: "unanswered",
          },
          {
            key: "answered",
            label: "Answered",
            activeIcon: AnsweredFillIcon,
            icon: AnsweredIcon,
            aria: "answered",
          },
          {
            key: "completed",
            label: "Completed",
            activeIcon: CompletedFillIcon,
            icon: CompletedIcon,
            aria: "completed",
          },
        ]
      : [
          {
            key: "messages",
            label: "Messages",
            activeIcon: MessageFillIcon,
            icon: MessageIcon,
            aria: "messages",
          },
        ]),
    ...(activeUnreadThreadList?.length > 0
      ? [
          {
            key: "thread",
            label: "Unread Threads",
            activeIcon: MessageFillIcon,
            icon: MessageIcon,
            aria: "thread",
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (activeUnreadThreadList?.length === 0) {
      dispatch(
        setChatboardSelectedTab(isSupportAdmin ? "unanswered" : "messages"),
      );
    }
  }, [activeUnreadThreadList]);
  useEffect(() => {
    if (isSupportAdmin) {
      dispatch(
        setChatboardSelectedTab(isSupportAdmin ? "unanswered" : "messages"),
      );
    }
  }, [isSupportAdmin]);

  return (
    <>
      <div className="head">
        <div className="user position-relative ">
          <div className="dropdown-container">
            <div className="avatar ">
              <PhoneSupportIcon width="24" height="24" />
            </div>
          </div>
          <div className="d-flex flex-column contact_info">
            <div className="name">{SUPPORT_NAME}</div>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="tab-container">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {TABS?.map((val) => {
            if (!getObjectLength(val)) return null;
            const {
              key,
              label,
              activeIcon: ActiveIcon,
              icon: Icon,
              aria,
            } = val || {};
            const isActive = chatboardSelectedTab === key;

            return (
              <li className="nav-item" role="presentation" key={key}>
                <button
                  className={`nav-link d-flex align-items-center ${
                    isActive ? "active" : ""
                  }`}
                  id={`${key}-tab`}
                  data-toggle="tab"
                  data-target={`#${aria}`}
                  type="button"
                  role="tab"
                  aria-controls={aria}
                  aria-selected={isActive}
                  onClick={() => handleTabing(key)}
                >
                  <span className="mr-1 d-inline-flex align-items-center">
                    {isActive ? (
                      <ActiveIcon
                        width="16"
                        height="16"
                        className="flip-icon"
                      />
                    ) : (
                      <Icon width="16" height="16" className="flip-icon" />
                    )}
                  </span>
                  <strong>{label}</strong>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default memo(SupportBoardHeader);
